import { validateFields } from './fieldValidation';
import { SET_VALIDATED } from 'constants/actionTypes';

/*
  Check form validity for all fields by native Form validation + custom check
  which constructs a validation result message.

  SPEC-23
*/
export const validateObject = (formRef) => (dispatch, getState) => {
  if (formRef.current === null) {
    return { isValid: false, invalidFields: [] };
  }

  const state = getState();
  // field label + reason validation failed
  const invalidFields = validateFields(Object.values(state.field.fields));
  // native validation to show invalid fields in red
  const isValidHTML = formRef.current.checkValidity();

  dispatch({ type: SET_VALIDATED });

  if (isValidHTML && invalidFields.length === 0) {
    return { isValid: true };
  }
  else {
    return { isValid: false, invalidFields };
  }
};

/*
  Compare original values to edited values

  Used for notifying user of differences if they try to exit without saving
*/
export const getUnsavedChanges = () => (dispatch, getState) => {
  const state = getState();

  if (state.object.saved) {
    return { changed: false };
  }

  const fields = state.field.fields;
  const unsavedChanges = [];

  for (let field of Object.values(fields)) {
    const editedValues = field.values.filter(v => v!== '');
    const originalValues = state.field.originalValues[field.predicate];

    const len = editedValues.length;
    const prevLen = originalValues.length;

    var isObjectField = false;
    if(len > 0){
      if(typeof editedValues[0] === 'object'){
        isObjectField = true;
      }
    }
    if(prevLen > 0){
      if(typeof originalValues[0] === 'object'){
        isObjectField = true;
      }
    }


    if (len !== prevLen) {
      if (len > prevLen) {
        if(!isObjectField){
          unsavedChanges.push(`${field.label} lisätty ${len - prevLen}`);
        }
      } 
      else {
        if(!isObjectField){
          unsavedChanges.push(`${field.label} poistettu ${prevLen - len}`);
        }
      }
      continue;
    }

    for (let i = 0; i < len; i++) {
      const edited = editedValues[i];
      const original = originalValues[i];

      if (typeof edited === 'object') {
        if (edited.uri !== original.uri) {
          unsavedChanges.push(`${field.label} muokattu arvoa ${i + 1}`);
        }
      } else if (edited !== original) {
        unsavedChanges.push(`${field.label} muokattu arvoa ${i + 1}`);
      }
    }
  }

  return {
    changed: unsavedChanges.length > 0,
    message: unsavedChanges
  };
};